var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, EventEmitter, } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { tap } from 'rxjs/operators';
import { EventsService } from '../../core/services/events-service/events.service';
import { AlertComponent } from '../../shared';
var PayByUploadModalComponent = /** @class */ (function () {
    function PayByUploadModalComponent(fb, eventsService) {
        this.fb = fb;
        this.eventsService = eventsService;
        this.showValidation = false;
        this.submitting = false;
        this.success = new EventEmitter();
        this.opened = false;
    }
    PayByUploadModalComponent.prototype.ngOnInit = function () {
        this.form = this.fb.group({
            document_id: ['', !this.bypassDocument && Validators.required],
        });
    };
    PayByUploadModalComponent.prototype.preparePayload = function () {
        return __assign({}, this.payload, { processor: 'pay_by_upload', document_id: this.form.get('document_id').value });
    };
    PayByUploadModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (this.submitting) {
            return;
        }
        if (this.form.invalid) {
            this.alert.newAlert('Please fill out required fields', 'danger');
            this.showValidation = true;
            return;
        }
        this.alert.newAlert('Submitting...', 'info');
        this.submitting = true;
        this.eventsService
            .postEntity(this.eventId, this.entity, this.preparePayload())
            .pipe(tap(function () { return (_this.submitting = false); }, function () { return (_this.submitting = false); }))
            .subscribe(function (res) {
            _this.success.next(res._html_message);
            // close and reset
            _this.modal.close();
            _this.form.reset();
            _this.alert.closeAlert();
            _this.opened = false;
        }, function (err) {
            _this.alert.newAlert((err && err.error && err.error.message) ||
                'There was an error in submitting your payment.', 'danger');
        });
    };
    PayByUploadModalComponent.prototype.onModalOpen = function () {
        this.form.enable();
        this.alert.closeAlert();
    };
    PayByUploadModalComponent.prototype.open = function () {
        this.modal.open();
        this.opened = true;
    };
    return PayByUploadModalComponent;
}());
export { PayByUploadModalComponent };
